import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// `prefix: 'tw'` matches `src/styles/tailwind.css`'s `prefix(tw)` import —
// without telling tailwind-merge about it, it can't recognize `tw:bg-...`
// as a Tailwind class at all and silently stops deduping conflicting ones.
const twMerge = extendTailwindMerge({ prefix: 'tw' });

/** shadcn/ui's standard class-merge helper — Tailwind-only, unrelated to the app's MUI `sx` prop. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
